'use strict';

angular.module('webAgro1App').directive('preventEvent', function () {
  return function(_scope, element) {
    $(element).click(function(event) {
      event.preventDefault();
      event.stopPropagation();
    });
    element.addClass('default');
  };
});
